"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const useHomepage_1 = __importDefault(require("../../hooks/useHomepage"));
const useHorizontalScroll_1 = __importDefault(require("../../hooks/useHorizontalScroll"));
const useRouting_1 = __importDefault(require("../../hooks/useRouting"));
const useTracking_1 = __importDefault(require("../../hooks/useTracking"));
const useTransparency_1 = __importDefault(require("../../hooks/useTransparency"));
const link_1 = __importDefault(require("../link"));
const styles_1 = require("./styles");
const Homes = ({ homes, highlight, hideActiveStyle, homeNamesMap }) => {
    const { isTransparent, changeTransparency, initialTransparency } = (0, useTransparency_1.default)();
    const { generateHomeUrl, customValidation } = (0, useRouting_1.default)();
    const { generateHomeHitConfig, isOpenDoor } = (0, useTracking_1.default)();
    const theme = (0, styled_components_1.useTheme)();
    const { highlighted, setHighlighted } = (0, useHomepage_1.default)();
    const { elRef: itemListRef, centerElement } = (0, useHorizontalScroll_1.default)();
    const [, setActiveHome] = (0, react_1.useState)();
    const [isOverflowing, setIsOverflowing] = (0, react_1.useState)(false);
    const visibleHomes = homes.filter((home) => !!home.displayName);
    (0, react_1.useEffect)(() => {
        setHighlighted(highlight);
    }, [highlight]);
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            var _a, _b;
            if (((_a = itemListRef === null || itemListRef === void 0 ? void 0 : itemListRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) && ((_b = itemListRef === null || itemListRef === void 0 ? void 0 : itemListRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth))
                setIsOverflowing(itemListRef.current.scrollWidth > itemListRef.current.clientWidth);
        };
        if (highlighted)
            centerElement(visibleHomes.findIndex((h) => h.name === highlighted.name), false);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleMouseEnter = (0, react_1.useCallback)((home) => {
        setActiveHome(home);
    }, [changeTransparency, isTransparent, itemListRef, theme.breakpoint.desktop]);
    const onClick = (0, react_1.useCallback)((home, index) => {
        const canSelectHome = customValidation ? customValidation({ home }) : !isOpenDoor;
        if (initialTransparency)
            changeTransparency(true);
        if (canSelectHome) {
            setHighlighted({ displayName: home.displayName, isReduced: home.isReduced, name: home.name });
            centerElement(index);
        }
    }, [changeTransparency, initialTransparency]);
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(styles_1.StyledNav, { isTransparent: isTransparent, children: (0, jsx_runtime_1.jsx)(styles_1.StyledList, { ref: itemListRef, "data-testid": "header-homes-list", "data-facil-iti": "header-homes-list", isOverflowing: isOverflowing, isTransparent: isTransparent, children: visibleHomes.map((home, index) => {
                    const isSelected = !hideActiveStyle && !!highlighted && highlighted.name === home.name;
                    const displayName = homeNamesMap && home.name && homeNamesMap[home.name] ? homeNamesMap[home.name] : home.displayName;
                    return ((0, jsx_runtime_1.jsx)(styles_1.StyledNavItem, { isSelected: isSelected, isTransparent: isTransparent, onMouseEnter: () => handleMouseEnter(home), "data-facil-iti": isSelected ? 'header-homes-list-item-active' : 'header-homes-list-item', children: (0, jsx_runtime_1.jsxs)(link_1.default, { href: generateHomeUrl(home), payload: { home }, onClick: () => onClick(home, index), hitConfig: generateHomeHitConfig({
                                currentPageName: highlighted ? highlighted.displayName || '' : '',
                                nextPageName: displayName,
                                index,
                                isOpenDoor: !!isOpenDoor,
                                isReduced: !!highlighted && !!highlighted.isReduced,
                                visibleOn: home.visibleOn,
                            }), children: [displayName, home.__typename === 'HomeHeader' && home.upperDisplayName && (0, jsx_runtime_1.jsx)(styles_1.NavItemSup, { children: home.upperDisplayName })] }) }, home.id));
                }) }) }) }));
};
exports.default = Homes;
